export default __webpack_public_path__ + "media/plus/password-visual-646e4b17.svg";